/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ForgotPasswordTokenRequest } from '../models';
/**
 * ForgotpasswordtokenApi - axios parameter creator
 * @export
 */
export const ForgotpasswordtokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate Forgot Password Token
         * @summary GET Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForgotPasswordToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getForgotPasswordToken', 'token', token)
            const localVarPath = `/forgot-password/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update new password with Forgot Password Token
         * @summary POST Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {ForgotPasswordTokenRequest} [forgotPasswordTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForgotPasswordToken: async (token: string, forgotPasswordTokenRequest?: ForgotPasswordTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('postForgotPasswordToken', 'token', token)
            const localVarPath = `/forgot-password/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForgotpasswordtokenApi - functional programming interface
 * @export
 */
export const ForgotpasswordtokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForgotpasswordtokenApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate Forgot Password Token
         * @summary GET Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForgotPasswordToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForgotPasswordToken(token, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ForgotpasswordtokenApi.getForgotPasswordToken']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update new password with Forgot Password Token
         * @summary POST Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {ForgotPasswordTokenRequest} [forgotPasswordTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postForgotPasswordToken(token: string, forgotPasswordTokenRequest?: ForgotPasswordTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postForgotPasswordToken(token, forgotPasswordTokenRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ForgotpasswordtokenApi.postForgotPasswordToken']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ForgotpasswordtokenApi - factory interface
 * @export
 */
export const ForgotpasswordtokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForgotpasswordtokenApiFp(configuration)
    return {
        /**
         * Validate Forgot Password Token
         * @summary GET Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForgotPasswordToken(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.getForgotPasswordToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Update new password with Forgot Password Token
         * @summary POST Forgot Password Token
         * @param {string} token Forgot Password Token
         * @param {ForgotPasswordTokenRequest} [forgotPasswordTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForgotPasswordToken(token: string, forgotPasswordTokenRequest?: ForgotPasswordTokenRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postForgotPasswordToken(token, forgotPasswordTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForgotpasswordtokenApi - object-oriented interface
 * @export
 * @class ForgotpasswordtokenApi
 * @extends {BaseAPI}
 */
export class ForgotpasswordtokenApi extends BaseAPI {
    /**
     * Validate Forgot Password Token
     * @summary GET Forgot Password Token
     * @param {string} token Forgot Password Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotpasswordtokenApi
     */
    public getForgotPasswordToken(token: string, options?: RawAxiosRequestConfig) {
        return ForgotpasswordtokenApiFp(this.configuration).getForgotPasswordToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update new password with Forgot Password Token
     * @summary POST Forgot Password Token
     * @param {string} token Forgot Password Token
     * @param {ForgotPasswordTokenRequest} [forgotPasswordTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForgotpasswordtokenApi
     */
    public postForgotPasswordToken(token: string, forgotPasswordTokenRequest?: ForgotPasswordTokenRequest, options?: RawAxiosRequestConfig) {
        return ForgotpasswordtokenApiFp(this.configuration).postForgotPasswordToken(token, forgotPasswordTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

